import React, { useCallback, useRef, useState } from 'react';
import { ITreeNodeContentProps, TreeNodeContent } from 'components/Tree/CommonTree/CommonTreeNode';
import { IWorkflowCatalogNode } from './WorkflowCatalogUtils';
import { Tooltip } from 'components/layout/Tooltip';
import { HtmlRenderer } from 'components/HtmlRenderer/HtmlRenderer';

export function WorkflowCatalogNode(props: React.PropsWithChildren<ITreeNodeContentProps<IWorkflowCatalogNode>>) {
  const elementRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(500);
  const onTooltipOpen = useCallback(() => {
    setMaxHeight(calculateMaxHeight(elementRef.current));
  }, []);

  if (props.data?.entityDescription?.length) {
    return (
      <Tooltip
        placement="right"
        onOpen={onTooltipOpen}
        title={
          <HtmlRenderer
            style={{ maxHeight: maxHeight }}
            className="dp-workflow-tree__tooltip"
            html={cleanupDescription(props.data.entityDescription)}
          />
        }
      >
        <div ref={elementRef} className="dp-workflow-tree__tooltip-node">
          <TreeNodeContent {...props} />
        </div>
      </Tooltip>
    );
  }
  return <TreeNodeContent {...props} />;
}

function cleanupDescription(description: string) {
  // eslint-disable-next-line no-control-regex
  return description.replace(/&quot/g, '"').replace(new RegExp('\n', 'g'), '<br />');
}

function calculateMaxHeight(element?: HTMLElement | null): number {
  const elementOffstePosition = element?.getBoundingClientRect().top ?? 0;
  const windowHeight = window.innerHeight;

  const possibleHeight = (windowHeight - elementOffstePosition - 34) * 2;

  if (possibleHeight < 500) {
    return possibleHeight;
  } else {
    return 500;
  }
}
